import dedent from 'ts-dedent';
import { MILES_TO_M } from '../const';
import { ColumnDataType, Provider, WorkflowComponentParamType } from '../types';
import { addColumn } from '../utils/schemas';
import { SelectWorkflowComponent } from './common/selectcomponent';
class Length extends SelectWorkflowComponent {
    constructor() {
        super({
            name: 'native.length',
            group: 'Spatial Operations',
            title: 'ST Length',
            description: `
      This component calculates the length
      of LineStrings in the input table.
      `
        }, [
            {
                name: 'source',
                type: WorkflowComponentParamType.InputTable,
                title: 'Source lines table'
            },
            {
                name: 'geo',
                type: WorkflowComponentParamType.Column,
                title: 'Geo column',
                parent: 'source',
                dataType: [ColumnDataType.Geography, ColumnDataType.Geometry]
            },
            {
                name: 'units',
                type: WorkflowComponentParamType.Selection,
                title: 'Units',
                options: ['Meters', 'Miles'],
                default: 'Meters'
            }
        ]);
    }
    getInnerSql({ params, connection }) {
        const convert = params.units === 'Meters' ? '' : ` / ${MILES_TO_M}`;
        switch (connection.type) {
            case Provider.Redshift:
            case Provider.Postgres:
                return dedent `SELECT
                  (
                    ST_LENGTH(${params.geo}::geography)
                  ) ${convert}
                  AS ${params.geo}_length, *
                FROM ${connection.quoteName(params.source)}`;
            case Provider.DatabricksRest:
                return dedent `SELECT /*+ REPARTITION(40) */
                  (
                    ST_LENGTH(${connection.processInputGeogColumn(params.geo)})
                  ) ${convert}
                  AS ${params.geo}_length, *
                FROM ${connection.quoteName(params.source)}`;
            default:
                return dedent `SELECT
                  (
                    ST_LENGTH(${connection.processInputGeogColumn(params.geo)})
                  ) ${convert}
                  AS ${params.geo}_length, *
                FROM ${connection.quoteName(params.source)}`;
        }
    }
    canProvideOutputSchemas() {
        return true;
    }
    getOutputSchema({ columns, params }) {
        return addColumn(columns.source, {
            name: `${params.geo}_length`,
            type: ColumnDataType.Number
        });
    }
}
export { Length };
